import { Radio, RadioGroup, Switch } from '@blueprintjs/core'
import * as React from 'react'
import isEmpty from 'lodash.isempty'
import Help from '../../../../../components/Help'
import ConfigureOptions from '../ConfigureOptions'
import { InputLabel } from '../../../../../components/inputs/InputLabel'
import { UprightStyle } from '../../../../../types'
import { templateStyles } from './templateStyles'

const styles: UprightStyle = {
  radioGroupContainer: { marginTop: 5 }
}

export const Form = ({ input, onFormPreviewChange, index }) => {
  const props = input.get('props')
  return (
    <div>
      <InputLabel
        title={props.get('label')}
        required={props.get('required') && isEmpty(props.get('value'))}
        requiredLabelStyle={templateStyles.requiredLabel}
        requiredLabelIconName={props.get('requiredLabelIconName')}
      >
        <div style={styles.radioGroupContainer}>
          <RadioGroup
            onChange={v => onFormPreviewChange(index, v.currentTarget.value)}
            inline={props.get('inline')}
            selectedValue={props.get('value')}
          >
            {props.get('options').map((opt, i) => {
              // eslint-disable-next-line react/no-array-index-key
              return <Radio key={i} label={opt.get('key')} value={opt.get('value')} />
            })}
          </RadioGroup>
          {props.get('helpText') && (
            <Help>
              <div>{props.get('helpText')}</div>
            </Help>
          )}
        </div>
      </InputLabel>
    </div>
  )
}

export const Configuration = ({ input, onChange }) => {
  const inputProps = input.get('props')
  return (
    <div>
      <Switch
        checked={inputProps.get('inline')}
        label="Inline"
        onChange={() => onChange('inline', !inputProps.get('inline'))}
      />
      <ConfigureOptions input={input} onChange={onChange} />
    </div>
  )
}
